import axios from 'axios';
import React, { useEffect, useState } from 'react';
import HitCourseZoneChart from '../../components/chart/HitCourseZoneChart';
import DefaultLoader from '../../components/loader/DefaultLoader';
import {useCookies} from 'react-cookie';
import _ from "lodash";
import ballImage from '../../assets/img/icon/ball_icon.png';
import dateSetting from '../../utils/dateSetting';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import HitLocationChart from '../../components/chart/HitLocationChart';
import { chooseColorCode } from '../../utils/color/commonColor';

function SprayChartMain({profile}) {
    const [cookies] = useCookies(['hiball_token']);
    let [sprayData, setSprayData] = useState([]);
    let dateObj = dateSetting();
    let {playerId, type, battingHand} = profile;
    let [season, setSeason] = useState(dateObj['selectboxSeason']);
    let [colorType, setColorType] = useState('hitResult');
    let [ballCodeCheck, setBallCodeCheck] = useState(true);
    let [hitResultCheck, setHitResultCheck] = useState(true);

    let [sprayLoading, setSprayLoading] = useState(false);

    let [checkObj, setCheckObj] = useState({
        6116: true, 6101: true, 6117: true, 6111: true,
        6108: true, 6103: true, 6107: true, 6199: true
    });

    let [hitCheckObj, setHitCheckObj] = useState({
        6613: true, 6610: true, 6607: true, 6604: true,
        6602: true, 6605: true, 6699: true
    });

    let todaySeason = (new Date()).getFullYear();
    const { t } = useTranslation();
    let useLang = localStorage.getItem('language');

    const ballCodeArr = [
        {name: 'fastball', code: 6116, color: '#ff0000'}, {name: 'sinker', code: 6101, color: '#ff7800'}, 
        {name: 'cutter', code: 6117, color: '#00ff00'}, {name: 'slider', code:6111, color: '#00aa00'},
        {name: 'curve', code: 6108, color: '#000000'}, {name: 'changeup', code: 6103, color: '#0000ff'}, 
        {name: 'splitter', code: 6107, color: '#a01ff0'}, {name: 'other', code:6199, color: '#ececec'}
    ]

    let hitResultObj = [
            {hitResultCode : 6613, hitResultName: '홈런', hitResultEng: 'homerun'},
            {hitResultCode : 6610, hitResultName: '3루타', hitResultEng: 'triple'},
            {hitResultCode : 6607, hitResultName: '2루타', hitResultEng: 'double'},
            {hitResultCode : 6604, hitResultName: '1루타', hitResultEng: 'single'},
            {hitResultCode : 6602, hitResultName: '플라이아웃', hitResultEng: 'flyout'},
            {hitResultCode : 6605, hitResultName: '땅볼아웃', hitResultEng: 'grounder'},
            {hitResultCode : 6699, hitResultName: '기타', hitResultEng: 'other'}
        ]

    useEffect(() => {
        // let {playerId} = profile;

        setSprayLoading(true);

        let params = {
                recordType: 'digestBattingRecord', recordName: 'selectBatterHitSparyRecord',
                // batterIds: playerId,
                seasons: season,
                gameTypeCode: 4201,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        
        if(type === "batter"){
            params['batterIds'] = playerId;
        } else {
            params['pitcherIds'] = playerId;
        }

        axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: params
        }).then((result) => {
            let data = result['data']['result'];
            checkOtherTypeHandler(data); // '기타'에 해당하는 항목 확인
            setSprayData(data);
            setSprayLoading(false);
        });
        
    }, [season]);

    function seasonHandler(event) {
        let value = event.target.value;
        setSeason(value);
    }

    function typeCodeHandler(event) {
        setColorType(event.target.value);
    }

    function ballCodeCheckHandler(event) {
        let id = event.currentTarget.id;
        let idSplit = id.split('-');
        let ballCode = idSplit[1];
        let checkStatus = checkObj[ballCode];

        setCheckObj({...checkObj, [ballCode]: !checkStatus});
    }

    function hitResultCheckHandler(event) {
        let id = event.currentTarget.id;
        let idSplit = id.split('-');
        let ballCode = idSplit[1];
        let checkStatus = hitCheckObj[ballCode];

        setHitCheckObj({...hitCheckObj, [ballCode]: !checkStatus});
    }

    function checkOtherTypeHandler(data){
        _.forEach(data, (item, idx) => {
            if(!(item['ballCode'] in checkObj)){
                item['ballCode'] = 6199; // '기타' 코드 값으로 대체
            }

            if(!(item['hitResultCode'] in hitCheckObj)){
                item['hitResultCode'] = 6699; // '기타' 코드 값으로 대체
            }
        });

        return data;
    }

    function changeBallCodeCheckHandler(evt) {
        // 전체구종 체크박스 이벤트 핸들러
        setBallCodeCheck(evt.target.checked);

        if(evt.target.checked){
            // 전체선택 시
            setCheckObj(
                Object.fromEntries(Object.keys(checkObj).map(key => [key, true]))
            );
        } else {
            // 전체해제 시
            setCheckObj(
                Object.fromEntries(Object.keys(checkObj).map(key => [key, false]))
            );
        }
    }

    function changeHitResultCheckHandler(evt) {
        // 전체결과 체크박스 이벤트 핸들러
        setHitResultCheck(evt.target.checked);

        if(evt.target.checked){
            // 전체선택 시
            setHitCheckObj(
                Object.fromEntries(Object.keys(hitCheckObj).map(key => [key, true]))
            );
        } else {
            // 전체해제 시
            setHitCheckObj(
                Object.fromEntries(Object.keys(hitCheckObj).map(key => [key, false]))
            );
        }
    }

    // if(sprayData.length === 0) {
    //     return <DefaultLoader />
    // }

    return (
        <>
        <div style={{position:'absolute', top: '7px', left: '7px'}}>
            <Form.Group onChange={seasonHandler} style={{display:'inline-block', height: '29px'}}>
                <Form.Select size="sm" defaultValue={dateObj['selectboxSeason']}>
                    <option value={todaySeason-2}>{todaySeason-2}</option>
                    <option value={todaySeason-1}>{todaySeason-1}</option>
                    <option value={todaySeason}>{todaySeason}</option>
                </Form.Select>
            </Form.Group>
        </div>
        <div className="boxTitle">
            <img src={ballImage} style={{height:'25px'}} alt='#'/> {t('sprayChart')}
        </div>
        <div style={{textAlign:'center'}}>
            <Row style={{ minHeight: "300px" }}>
                <Col md={5}>
                    {sprayLoading 
                        ? <DefaultLoader /> 
                        : <HitLocationChart  
                            playerType={type} 
                            battingHand={battingHand}
                            data={sprayData} 
                            checkObj={checkObj}
                            hitCheckObj={hitCheckObj}
                            colorType={colorType}
                            name={''} 
                            filter={[]}
                        />
                    }
                </Col>
                <Col>
                    {sprayLoading 
                        ? <DefaultLoader />
                        : <HitCourseZoneChart 
                            data={sprayData} 
                            ballCodeArr={ballCodeArr} 
                            hitResultObj={hitResultObj}
                            colorType={colorType} 
                            checkObj={checkObj}
                            hitCheckObj={hitCheckObj}
                        />
                    }
                </Col>
            </Row>
        </div>
        <div style={{display: "flex" , alignItems: "center"}}>
            <div style={{paddingLeft: "10px"}}>
                <Form.Check
                    inline
                    type={'checkbox'}
                    id={'ballCodeCheck'}
                    label={t('allBallType')}
                    onClick={changeBallCodeCheckHandler}
                    defaultChecked={ballCodeCheck}
                    style={{ fontSize: "14px", paddingTop: "5px"}}
                />
            </div>
            <div style={{display:'inline-block', paddingLeft: '240px' ,paddingRight: '5px'}}>{t('color')}</div>
            <div style={{display:'inline-block'}}>
                <Form.Group onChange={typeCodeHandler} style={{display:'inline-block', height: '29px'}}>
                    <Form.Select size="sm" defaultValue={'hitResult'}>
                        <option value='hitResult'>{t('hitResult')}</option>
                        <option value='ballCode'>{t('ballType')}</option>
                    </Form.Select>
                </Form.Group>
            </div>
            <div style={{paddingLeft: "20px"}}>
                <Form.Check
                    inline
                    type={'checkbox'}
                    id={'hitResultCheck'}
                    label={t('allHitResult')}
                    onClick={changeHitResultCheckHandler}
                    defaultChecked={hitResultCheck}
                    style={{ fontSize: "14px", paddingTop: "5px"}}
                />
            </div>
        </div>
        <div>
            <Row>
                <Col>
                    <Form>
                        <div style={{display:'flex', flexWrap: 'wrap', 
                        justifyContent: 'center', marginTop:'10px'}}>
                            {ballCodeArr.map((item, idx) => (
                                <div style={ useLang === "en" 
                                    ? {width:'88px', border: `1px solid ${item['color']}`, 
                                        padding: '2px 5px', borderRadius: '4px', margin: '2px', cursor:'pointer',
                                        fontSize: '12px', textAlign:"center"} 
                                    : {width:'85px', border: `1px solid ${item['color']}`, 
                                        padding: '2px 5px', borderRadius: '4px', margin: '2px', cursor:'pointer',
                                        fontSize: '13px'}}
                                key={`check-${item['code']}`}
                                onClick={ballCodeCheckHandler}
                                id={`div-${item['code']}`}
                                >
                                    <Form.Check size='sm'
                                    checked={checkObj[item['code']]}
                                    readOnly
                                    // onChange={ballCodeCheckHandler}
                                    inline
                                    name="group1"
                                    type={'checkbox'}
                                    id={`check-${item['code']}`}
                                    width={'100px'}
                                    style={useLang === "en" ? { marginRight:"5px", float:"left"} : {}}
                                    />
                                {t(item['name'])}
                                </div>
                            ))}
                        </div>
                    </Form>
                </Col>
                <Col>
                    <Form>
                        <div style={{display:'flex', flexWrap: 'wrap', 
                        justifyContent: 'center', marginTop:'10px'}}>
                            {hitResultObj.map((item, idx) => (
                                <div style={ useLang === "en" 
                                    ? {width:'88px', border: `1px solid ${chooseColorCode(item['hitResultCode'])}`, 
                                        padding: '2px 5px', borderRadius: '4px', margin: '2px', cursor:'pointer',
                                        fontSize: '12px', textAlign:"center"} 
                                    : {width:'85px', border: `1px solid ${chooseColorCode(item['hitResultCode'])}`, 
                                        padding: '2px 5px', borderRadius: '4px', margin: '2px', cursor:'pointer',
                                        fontSize: '13px'}}
                                key={`check-${item['hitResultCode']}`}
                                onClick={hitResultCheckHandler}
                                id={`div-${item['hitResultCode']}`}
                                >
                                    <Form.Check size='sm'
                                    checked={hitCheckObj[item['hitResultCode']]}
                                    readOnly
                                    // onChange={hitResultCheckHandler}
                                    inline
                                    name="group1"
                                    type={'checkbox'}
                                    id={`check-${item['hitResultCode']}`}
                                    width={'100px'}
                                    style={useLang === "en" ? { marginRight:"5px", float:"left"} : {}}
                                    />
                                        {useLang === "en" ? t(item['hitResultEng']) : t(item['hitResultEng']).substring(0,3)}
                                </div>
                            ))}
                        </div>
                    </Form>
                </Col>
            </Row>
        </div>
        </>
    )
}

export default SprayChartMain;